import React from 'react';

const LandingPageContainer = ({ children, additionalclasses }) => {
    return (
        <div className={`max-w-[90%] lg:max-w-[1400px]  lg:px-[50px] m-auto px-[16px] lg:gap-[32px] ${additionalclasses}`}>
            {children}
        </div>
    );
};

export default LandingPageContainer;